"use client";

import Benefits from "@/components/LandingPage/Benefits";
import CTA from "@/components/LandingPage/CTA";
import FAQ from "@/components/LandingPage/FAQ";
import Features from "@/components/LandingPage/Features";
import Footer from "@/components/LandingPage/Footer";
import Header from "@/components/LandingPage/Header";
import Hero from "@/components/LandingPage/Hero";
import Pricing from "@/components/LandingPage/Pricing";
import Testimonials from "@/components/LandingPage/Testimonials";

export default function Page() {
  return (
    <>
      <Header />
      <Hero />
      <Features />
      <Benefits />
      <Testimonials />
      <Pricing page="lp" />
      <FAQ />
      <CTA />
      <Footer />
    </>
  );
}
